class SelectedArticlesList extends HTMLElement {
  connectedCallback() {
    this.postsPerPage = parseInt(this.dataset.postsPerPage) || 9;
    this.grid = this.querySelector('[data-selected-grid]');
    this.paginationEl = this.querySelector('[data-selected-pagination]');
    // Snapshot the server-rendered cards, then let JS own pagination.
    this.allItems = this.grid ? [...this.grid.querySelectorAll('[data-selected-item]')] : [];
    if (this.allItems.length <= this.postsPerPage) return; // nothing to paginate

    this.readUrl();
    this.render();

    window.addEventListener('popstate', () => {
      this.readUrl();
      this.render();
    });
  }

  get pageParam() {
    return this.dataset.pageParam || 'sp';
  }

  readUrl() {
    const p = new URLSearchParams(window.location.search);
    this.page = parseInt(p.get(this.pageParam) || '1');
  }

  navigate(page) {
    const p = new URLSearchParams(window.location.search);
    if (page > 1) p.set(this.pageParam, String(page));
    else p.delete(this.pageParam);
    const qs = p.toString();
    history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
    this.page = page;
    this.render();
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  render() {
    const totalPages = Math.max(1, Math.ceil(this.allItems.length / this.postsPerPage));
    if (this.page > totalPages || this.page < 1) this.page = 1;
    const start = (this.page - 1) * this.postsPerPage;
    const pageItems = this.allItems.slice(start, start + this.postsPerPage);

    this.grid.innerHTML = '';
    pageItems.forEach((item) => this.grid.appendChild(item.cloneNode(true)));

    this.renderPagination(this.page, totalPages);
  }

  renderPagination(current, total) {
    if (!this.paginationEl) return;
    if (total <= 1) { this.paginationEl.innerHTML = ''; return; }

    const chevL = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1L1 5L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    const chevR = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const prevContent = `${chevL} <span>Previous</span>`;
    const nextContent = `<span>Next</span> ${chevR}`;

    const visible = new Set([1, total]);
    for (let i = Math.max(1, current - 1); i <= Math.min(total, current + 1); i++) visible.add(i);
    const pages = [...visible].sort((a, b) => a - b);

    const items = [];
    let prev = 0;
    for (const p of pages) {
      if (prev && p - prev > 1) items.push(null);
      items.push(p);
      prev = p;
    }

    const btn = (p, label) =>
      `<li class="all-blogs-pagination__item"><button type="button" class="all-blogs-pagination__link" data-page="${p}" aria-label="${label}">${p}</button></li>`;

    let html = `<nav class="all-blogs-pagination">`;

    html += `<div class="all-blogs-pagination__nav all-blogs-pagination__nav--prev">${current > 1
      ? `<button type="button" class="all-blogs-pagination__link-arrow" data-page="${current - 1}" aria-label="Previous">${prevContent}</button>`
      : `<span class="all-blogs-pagination__link-arrow all-blogs-pagination__link--disabled" aria-disabled="true">${prevContent}</span>`
      }</div>`;

    html += `<ul class="all-blogs-pagination__list" role="list">`;

    for (const p of items) {
      if (p === null) {
        html += `<li class="all-blogs-pagination__item"><span class="all-blogs-pagination__link all-blogs-pagination__link--gap" aria-hidden="true">&hellip;</span></li>`;
      } else if (p === current) {
        html += `<li class="all-blogs-pagination__item"><span class="all-blogs-pagination__link all-blogs-pagination__link--current" aria-current="page">${p}</span></li>`;
      } else {
        html += btn(p, `Page ${p}`);
      }
    }

    html += `</ul>`;

    html += `<div class="all-blogs-pagination__nav all-blogs-pagination__nav--next">${current < total
      ? `<button type="button" class="all-blogs-pagination__link-arrow" data-page="${current + 1}" aria-label="Next">${nextContent}</button>`
      : `<span class="all-blogs-pagination__link-arrow all-blogs-pagination__link--disabled" aria-disabled="true">${nextContent}</span>`
      }</div>`;

    html += `</nav>`;
    this.paginationEl.innerHTML = html;

    this.paginationEl.querySelectorAll('[data-page]').forEach((b) => {
      b.addEventListener('click', () => this.navigate(parseInt(b.dataset.page)));
    });
  }
}

if (!customElements.get('selected-articles-list')) {
  customElements.define('selected-articles-list', SelectedArticlesList);
}
